import { render, staticRenderFns } from "./detailed.vue?vue&type=template&id=6ad442ca&scoped=true&"
import script from "./detailed.vue?vue&type=script&lang=js&"
export * from "./detailed.vue?vue&type=script&lang=js&"
import style0 from "./detailed.vue?vue&type=style&index=0&id=6ad442ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad442ca",
  null
  
)

export default component.exports